
/*
These functions make sure WordPress
and Foundation play nice together.
*/
(function($) { 
	$(document).ready(function() {

		var $mainHeader = $('#mainHeader');
		
		// Remove empty P tags created by WP inside of Accordion and Orbit
		$('.accordion p:empty, .orbit p:empty').remove();

		// Adds Flex Video to YouTube and Vimeo Embeds
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
			if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
				$(this).wrap("<div class='widescreen responsive-embed'/>");
			} else {
				$(this).wrap("<div class='responsive-embed'/>");
			}
		});

		// hamburger
		function hamburgerNav() {
			var $hb = $('.hamburger');
			$hb.on('click', function(e){
					e.preventDefault();
					$(this).toggleClass('is-active');
			});
		}
		hamburgerNav();

		$(window).on('scroll', function() {
			var $this = $(this);
			var $logoWhite = $('.logo-wht');
			var $logoColor = $('.logo-clr');
			if ($this.scrollTop() > 80) {
				$mainHeader.addClass('bck-not-transparent').removeClass('bck-transparent');
				$logoWhite.hide();
				$logoColor.show();
			} else {
				$mainHeader.removeClass('bck-not-transparent').addClass('bck-transparent');
				$logoWhite.show();
				$logoColor.hide();
			}
	  });

		// headroom
		$mainHeader.headroom({
			"offset": 500,
			"tolerance": 10,
			"classes": {
				"initial": "animated",
				"pinned": "slideDown",
				"unpinned": "slideUp"
			},
			onTop : function() { 
				$('body').addClass("header--pinned");
				
			},
			onNotTop : function() {
				$('body').removeClass("header--pinned");
			},
		});
		

		function featuredHome() {
			var $homePost = $(".featured-home-posts");

			if (($homePost).length) {
				$homePost.slick({
					autoplay: true,
					  autoplaySpeed: 5000,
					  dots: true
				});
			}
		}
		featuredHome();
		
		
		function featuredArchive() {
			var $featuredArchive = $('.featured-archive-posts');

			if (($featuredArchive).length) {
				$featuredArchive.slick({
					autoplay: true,
					autoplaySpeed: 5000,
					dots: true
				});
			}
		}
		featuredArchive();
		


		function floatingLabel() {
				//Detect browser's user agent and add to HTML attribute.
				var doc = document.documentElement;
				doc.setAttribute('data-useragent', navigator.userAgent);
				

				//Since HubSpot forms are rendered after the DOM builds, you must trigger the manipulation after the window loads

				window.onload = function () {
				
					//turn autocomplete off for forms on all browsers, except Chrome
					$('form').attr('autocomplete','off');
					$('input').attr('autocomplete','off');

					//turn autocomplete off for forms for Chrome 
					//based on a browser bug noted here: https://bugs.chromium.org/p/chromium/issues/detail?id=370363#c7
					$('html[data-useragent*="Chrome"] form').attr('autocomplete','false');
					$('html[data-useragent*="Chrome"] form input').attr('autocomplete','false');

					var $formSliderInput = $(".form-with-slider-labels .hs-input");
					
					$formSliderInput.focus(function(){
						$(this).closest(".hs-form-field").removeClass("not-focused");
						$(this).closest(".hs-form-field").addClass("has-focus");
					}).blur(function(){
						if( !$(this).val() ) { //check to see if the input has a value
							$(this).closest(".hs-form-field").removeClass("has-focus");
							$(this).closest(".hs-form-field").addClass("not-focused");
						} else {
							$(this).closest(".hs-form-field").addClass("has-value");
						}
					})
					//on input change, if the value is empty, remove "has-value" class.
					
					$formSliderInput.on("change paste keyup", function() {
						if( !$(this).val() ) { //check to see if the input has a value
						$(this).closest(".hs-form-field").removeClass("has-value");
						}
					});
				};   
		}

		floatingLabel();

	}); 
})(jQuery);